import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';

import { useApplicationContext } from 'shared/utils/applicationContext';

/**
 * Локальный error boundary для некритичных блоков: при ошибке рендера скрывает только сам блок,
 * не давая ошибке дойти до корневого boundary и стереть контент страницы.
 */
export const BlockErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { logger } = useApplicationContext();

  return <ErrorLogComponent logger={logger}>{children}</ErrorLogComponent>;
};
